import { Permission } from '@cims-online/shared'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { useCreateOrganizationMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import {
  Organization,
  useOrganizationsTableContext,
} from '../../../../OrganizationsTableContext'
import { CreateOrganizationModalBody } from './components/CreateOrganizationModalBody'
import { useProjectContext } from 'context/ProjectContext'

export function useCreateOptions(): CreateHeaderActionOptions<Organization> {
  const { projectId } = useProjectContext()
  const { refetch, fetching } = useOrganizationsTableContext()
  const [createOrganization] = useCreateOrganizationMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createDSOrganization: {
        organization: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    loading: fetching,
    entity: 'Organization',
    permission: Permission.CreateDesignSubmittalOrganization,
    modal: {
      type: 'simple',
      body: <CreateOrganizationModalBody />,
      onOk: async ({ name, description }) => {
        await createOrganization({
          variables: {
            createOrganizationInput: { projectId, name, description },
          },
        })
        refetch()
      },
    },
  }
}
